import React from "react";
import { FiCheckCircle, FiGrid, FiZap } from "react-icons/fi";
import { CgUnavailable } from "react-icons/cg";

import OldMinimalProfileBlock from "./OldMinimalProfileBlock";
import OldMinimalCalendar from "./OldMinimalCalendar";
import OldMinimalTimeSlots from "./OldMinimalTimeSlots";
import OldMinimalSlotBookingForm from "./OldMinimalSlotBookingForm";
import AssessmentForm from "../Calender/ProfileCalendar/AssessmentForm.jsx";

const ACCENT = "#161616";

const ModeCard = ({ active, onClick, title, sub, isMobile }) => {
  return (
    <div
      onClick={onClick}
      style={{
        border: `2px solid ${active ? ACCENT : "#e5e5e5"}`,
        borderRadius: 12,
        padding: isMobile ? "14px" : "14px 16px",
        cursor: "pointer",
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        background: active ? "#f5f5f5" : "#fff",
        transition: "border 0.15s, background 0.15s",
        flex: 1,
      }}
    >
      <div
        style={{
          width: 18,
          height: 18,
          borderRadius: "50%",
          border: `2px solid ${active ? ACCENT : "#ccc"}`,
          background: active ? ACCENT : "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          marginTop: 2,
          transition: "all 0.15s",
        }}
      >
        {active && (
          <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#fff" }} />
        )}
      </div>
      <div>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#161616", marginBottom: 2 }}>
          {title}
        </div>
        <div style={{ fontSize: 11, color: "#777", lineHeight: 1.4 }}>{sub}</div>
      </div>
    </div>
  );
};

const OldMinimalBookingPage = ({
  state,
  setState,
  updateState,
  isHovered,
  setIsHovered,
  setShowServiceDropdown,
  setScrollPosition,
  setCurrentIndex,
  API_URL,
  calYear,
  calMonth,
  setCalMonth,
  setCalYear,
  packageDays,
  viewAvailableSlot,
  showServiceDropdown,
  serviceError,
  setServiceError,
  timeSlots,
  confirmDetails,
  uploadDetails,
  recaptcha,
  isMobile,
  REACT_APP_SITE_KEY,
  optionsMenu,
  onBack,
  hideProfile = false,
}) => {
  return (
    <div
      ref={optionsMenu}
      className={hideProfile ? "w-100" : "p-3 d-flex g-1 flex-wrap w-100 flex-wrap calendar-wrapper-an"}
      style={{ width: "100%" }}
    >
      {!hideProfile && (
        <OldMinimalProfileBlock
          state={state}
          isHovered={isHovered}
          setIsHovered={setIsHovered}
          setState={setState}
          setShowServiceDropdown={setShowServiceDropdown}
          setScrollPosition={setScrollPosition}
          setCurrentIndex={setCurrentIndex}
          API_URL={API_URL}
          onBack={onBack}
        />
      )}

      <section className="cal-small-box box-rd" style={{ width: "100%", boxSizing: "border-box" }}>
        {state.assessmentForm ? (
          <AssessmentForm
            questions={state.assessmentQuestions}
            updateAssessment={(data) => {
              setState((previous) => ({
                ...previous,
                assessmentAnswer: data,
                assessmentForm: false,
                assessmentNeed: false,
                detailsPage: true,
              }));
            }}
          />
        ) : state.detailsPage ? (
          <OldMinimalSlotBookingForm
            state={state}
            updateState={updateState}
            uploadDetails={uploadDetails}
            recaptcha={recaptcha}
            isMobile={isMobile}
            REACT_APP_SITE_KEY={REACT_APP_SITE_KEY}
            onConfirm={() => confirmDetails()}
          />
        ) : (
          <div className="slotChoseingParent" style={{ padding: isMobile ? "1rem" : "1.5rem" }}>
            <div style={{ paddingBottom: isMobile ? "1.5rem" : "2rem" }}>
              <h6 className="font-weight-bold mt-2 mb-3" style={{ fontSize: isMobile ? 15 : 17 }}>
                How would you like to book?
              </h6>

              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  gap: 10,
                  marginBottom: "1.25rem",
                }}
              >
                <ModeCard
                  active={state.bookingMode === "self" || !state.bookingMode}
                  onClick={() => {
                    updateState("bookingMode", "self");
                    updateState("expertNote", "");
                  }}
                  title="I'll pick date & time"
                  sub="Select from available slots"
                  isMobile={isMobile}
                />
                <ModeCard
                  active={state.bookingMode === "expert"}
                  onClick={() => updateState("bookingMode", "expert")}
                  title="Let the expert choose"
                  sub="Share preference, expert will schedule"
                  isMobile={isMobile}
                />
              </div>

              {state.bookingMode === "expert" && (
                <div style={{ marginBottom: "1.25rem" }}>
                  <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#555", marginBottom: 6 }}>
                    Share your preference / availability
                  </label>
                  <textarea
                    value={state.expertNote || ""}
                    onChange={(e) => updateState("expertNote", e.target.value)}
                    placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      border: "1.5px solid #e0e0e0",
                      borderRadius: 10,
                      padding: "10px 12px",
                      fontSize: 16,
                      color: "#161616",
                      outline: "none",
                      fontFamily: "inherit",
                      resize: "vertical",
                      minHeight: 90,
                      caretColor: "black",
                      transition: "border 0.15s",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = ACCENT)}
                    onBlur={(e) => (e.target.style.borderColor = "#e0e0e0")}
                  />
                  <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>
                    The expert will review your preference and send you a confirmed slot via email.
                  </div>

                  <button
                    style={{
                      marginTop: "1rem",
                      width: "100%",
                      background: ACCENT,
                      color: "#fff",
                      border: "none",
                      borderRadius: 10,
                      padding: "12px 16px",
                      fontSize: 14,
                      fontWeight: 700,
                      cursor: state.expertNote?.trim() ? "pointer" : "not-allowed",
                      opacity: state.expertNote?.trim() ? 1 : 0.6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      fontFamily: "inherit",
                    }}
                    onClick={() => {
                      if (state.expertNote?.trim()) confirmDetails();
                    }}
                  >
                    Request Expert Scheduling →
                  </button>
                </div>
              )}

              {(state.bookingMode === "self" || !state.bookingMode) && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 8,
                      background: "#fffbeb",
                      border: "1px solid #fde68a",
                      borderRadius: 10,
                      padding: "10px 12px",
                      marginBottom: "1rem",
                    }}
                  >
                    <FiZap size={14} style={{ color: "#d97706", marginTop: 1, flexShrink: 0 }} />
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#92400e", marginBottom: 2 }}>
                        Instant confirmation
                      </div>
                      <div style={{ fontSize: 11, color: "#78350f", lineHeight: 1.4 }}>
                        Your session will be confirmed immediately after booking.
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 8,
                      marginBottom: "1.25rem",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        background: ACCENT,
                        color: "#fff",
                        borderRadius: 999,
                        padding: "5px 12px",
                        fontSize: 11,
                        fontWeight: 600,
                      }}
                    >
                      <FiCheckCircle size={12} /> Selected slot
                    </span>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        background: "#f5f5f5",
                        color: "#4a5568",
                        borderRadius: 999,
                        padding: "5px 12px",
                        fontSize: 11,
                        fontWeight: 600,
                      }}
                    >
                      <FiGrid size={12} /> Booked
                    </span>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        background: "#f5f5f5",
                        color: "#a0a0a8",
                        borderRadius: 999,
                        padding: "5px 12px",
                        fontSize: 11,
                        fontWeight: 600,
                      }}
                    >
                      <CgUnavailable size={12} /> Not available
                    </span>
                  </div>

                  <h6 className="font-weight-bold mt-4 mb-3" style={{ fontSize: isMobile ? 14 : 16 }}>
                    {state.type === "day" ? "Available date" : "When should we meet?"}
                  </h6>

                  {/* Calendar and time slots — always stacked vertically, never side by side */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: isMobile ? "16px" : "20px",
                      marginTop: "12px",
                      width: "100%",
                    }}
                  >
                    <OldMinimalCalendar
                      state={state}
                      calYear={calYear}
                      calMonth={calMonth}
                      setCalMonth={setCalMonth}
                      setCalYear={setCalYear}
                      packageDays={packageDays}
                      viewAvailableSlot={viewAvailableSlot}
                    />
                    <OldMinimalTimeSlots
                      state={state}
                      setState={setState}
                      showServiceDropdown={showServiceDropdown}
                      serviceError={serviceError}
                      setServiceError={setServiceError}
                      timeSlots={timeSlots}
                      isMobile={isMobile}
                    />
                  </div>

                  <button
                    style={{
                      alignSelf: "flex-end",
                      marginTop: "1.25rem",
                      backgroundColor: ACCENT,
                      color: "#ffffff",
                      border: "none",
                      borderRadius: "10px",
                      padding: isMobile ? "13px 20px" : "13px 20px",
                      fontWeight: "600",
                      fontSize: "14px",
                      cursor: "pointer",
                      width: "100%",
                    }}
                    onClick={() => confirmDetails()}
                  >
                    Confirm Details
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default OldMinimalBookingPage;